import React from 'react';

import PropTypes from 'prop-types';
import { magma } from 'react-magma-dom';

export const LogoVariant = {
  dark: 'dark',
  light: 'light',
};

const logoGeometry = {
  [LogoVariant.light]: {
    viewBox: '0 0 276 274',
    container:
      'M128.239 3.45844C134.304 0.0665896 141.696 0.0665863 147.761 3.45844L265.459 69.2745C271.782 72.8098 275.698 79.4872 275.698 86.7307V188.657C275.698 195.96 271.717 202.683 265.314 206.194L147.615 270.728C141.626 274.012 134.374 274.012 128.384 270.728L10.6865 206.194C4.28271 202.683 0.301941 195.96 0.301941 188.657V86.7307C0.301941 79.4872 4.21844 72.8099 10.5406 69.2746L128.239 3.45844Z',
    top: 'M21.5131 78.4593L129.346 19.2763C135.021 16.2412 140.696 16.2412 146.372 19.2763L254.204 78.4593C261.772 83.0119 261.772 87.5644 254.204 92.117L146.372 151.3C140.696 154.335 135.021 154.335 129.346 151.3L21.5131 92.117C13.9459 87.5644 13.9459 83.0119 21.5131 78.4593Z',
    center:
      'M106.882 83.3521L135.592 67.4037C137.103 66.5858 138.614 66.5858 140.125 67.4037L168.836 83.3521C170.85 84.5789 170.85 85.8057 168.836 87.0325L140.125 102.981C138.614 103.799 137.103 103.799 135.592 102.981L106.882 87.0325C104.867 85.8057 104.867 84.5789 106.882 83.3521Z',
    bottom:
      'M13 133.659L129.346 197.395C135.021 200.43 140.696 200.43 146.372 197.395L262.717 133.659V182.03C262.717 187.72 259.88 192.083 254.204 195.118L146.372 254.301C140.696 257.336 135.021 257.336 129.346 254.301L21.5131 195.118C15.8377 192.083 13 187.72 13 182.03V133.659Z',
  },
  [LogoVariant.dark]: {
    viewBox: '0 0 276 274',
    container:
      'M128.239 3.45844C134.304 0.0665896 141.696 0.0665863 147.761 3.45844L265.459 69.2745C271.782 72.8098 275.698 79.4872 275.698 86.7307V188.657C275.698 195.96 271.717 202.683 265.314 206.194L147.615 270.728C141.626 274.012 134.374 274.012 128.385 270.728L10.6865 206.194C4.28272 202.683 0.301956 195.96 0.301956 188.657V86.7307C0.301956 79.4872 4.21846 72.8099 10.5406 69.2746L128.239 3.45844Z',
    top: 'M21.5131 78.4593L129.346 19.2763C135.021 16.2412 140.696 16.2412 146.372 19.2763L254.204 78.4593C261.772 83.0119 261.772 87.5644 254.204 92.117L146.372 151.3C140.696 154.335 135.021 154.335 129.346 151.3L21.5131 92.117C13.9459 87.5644 13.9459 83.0119 21.5131 78.4593Z',
    center:
      'M106.882 83.3521L135.592 67.4037C137.103 66.5858 138.614 66.5858 140.125 67.4037L168.836 83.3521C170.85 84.5789 170.85 85.8057 168.836 87.0325L140.125 102.981C138.614 103.799 137.103 103.799 135.592 102.981L106.882 87.0325C104.867 85.8057 104.867 84.5789 106.882 83.3521Z',
    bottom:
      'M13 133.659L129.346 197.395C135.021 200.43 140.696 200.43 146.372 197.395L262.717 133.659V182.03C262.717 187.72 259.88 192.083 254.204 195.118L146.372 254.301C140.696 257.336 135.021 257.336 129.346 254.301L21.5131 195.118C15.8377 192.083 13 187.72 13 182.03V133.659Z',
  },
};

export const Logo = ({ variant = LogoVariant.light }) => {
  const isDarkVariant = variant === LogoVariant.dark;
  const geometry = logoGeometry[variant];

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height="24"
      viewBox={geometry.viewBox}
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={geometry.container}
        fill={isDarkVariant ? magma.colors.neutral0 : magma.colors.brand.navy}
      />
      <path
        d={geometry.top}
        fill={isDarkVariant ? magma.colors.brand.navy : magma.colors.neutral0}
      />
      <path d={geometry.center} fill={magma.colors.brand.sunriseOrange} />
      <path d={geometry.bottom} fill={magma.colors.brand.skyBlue} />
    </svg>
  );
};

Logo.propTypes = {
  variant: PropTypes.oneOf(Object.values(LogoVariant)),
};
